import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages.component';
import { HomeComponent } from './home/home.component';
import { UsersComponent } from './users/users.component';
import { PushNotificationsComponent } from './push-notifications/push-notifications.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { AuthGuard } from '../services/service.index';
import { NotificationCalendarComponent } from './notificationcalendar/notificationcalendar.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { PrivacyPolicyComponent } from '../shared/legal/privacy-policy/privacy-policy.component';




const pagesRoutes: Routes = [
    {
        path: '',
        component: PagesComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: 'home', component: HomeComponent, data: { title: 'Inicio' } },
            { path: 'users', component: UsersComponent, data: { title: 'Control de Usuarios' } },
            { path: 'push-notifications', component: PushNotificationsComponent, data: { title: 'Notificaciones Push' } },
            { path: 'account', component: AccountSettingsComponent, data: { title: 'Perfil' } },
            { path: 'calendar', component: NotificationCalendarComponent, data: { title: 'Notificaciones Semanales' } },
            { path: 'schedule', component: ScheduleComponent, data: { title: 'Agendas' } },
            { path: '', redirectTo: '/login', pathMatch: 'full' }
        ],
    },
    
    

];

export const PAGES_ROUTES = RouterModule.forChild(pagesRoutes);
